export default __webpack_public_path__ + "static/11_Screenshot-558102b9e3d90a73c08b24c01fed21e0.png";